import React, { memo } from 'react';
import { useParams } from 'react-router';

import { Box } from '@mui/material';
import CustomFieldsSection from 'app/shared/components/customFields/CustomFieldsSection';
import { CUSTOM_FIELDS_TARGET } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';
import PropTypes from 'prop-types';

const CustomFields = ({ className, customFieldsController }) => {
  const { applicationId, entityId } = useParams();

  return (
    <Box className={className}>
      <CustomFieldsSection
        applicationId={applicationId}
        controller={customFieldsController}
        target={CUSTOM_FIELDS_TARGET.NBE}
        targetEntityId={entityId}
      />
    </Box>
  );
};

CustomFields.propTypes = {
  customFieldsController: PropTypes.shape({
    definitions: PropTypes.array.isRequired,
    formValues: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default memo(CustomFields);
